import React, { useState } from "react";
import "./AgentDashboard.css";

const AgentDashboard = () => {
  const initialData = [
    { id: "TXN-2026-01", date: "2026-05-15", agentName: "Rajesh Sharma", branch: "Mumbai Main", product: "Loan Disbursed", sourceAmount: 1200000, fixedComm: 1000, percentage: 1.5, status: "Paid" },
    { id: "TXN-2026-02", date: "2026-05-14", agentName: "Anjali Desai", branch: "Delhi NCR", product: "EMI Collection", sourceAmount: 25000, fixedComm: 50, percentage: 0.5, status: "Pending" },
    { id: "TXN-2026-03", date: "2026-05-12", agentName: "Vikram Singh", branch: "Bangalore", product: "FD (Fixed Deposit)", sourceAmount: 500000, fixedComm: 0, percentage: 2.0, status: "Paid" },
    { id: "TXN-2026-04", date: "2026-05-10", agentName: "Rajesh Sharma", branch: "Mumbai Main", product: "Savings Account", sourceAmount: 10000, fixedComm: 200, percentage: 0, status: "Paid" },
    { id: "TXN-2026-05", date: "2026-05-08", agentName: "Neha Gupta", branch: "Kolkata", product: "Loan Applied", sourceAmount: 800000, fixedComm: 500, percentage: 0.2, status: "Pending" },
    { id: "TXN-2026-06", date: "2026-05-07", agentName: "Anjali Desai", branch: "Delhi NCR", product: "RD (Recurring)", sourceAmount: 5000, fixedComm: 100, percentage: 1.0, status: "On Hold" },
    { id: "TXN-2026-07", date: "2026-05-06", agentName: "Vikram Singh", branch: "Bangalore", product: "MIS (Monthly Income)", sourceAmount: 300000, fixedComm: 0, percentage: 1.8, status: "Paid" }
  ];

  const [filters, setFilters] = useState({ searchQuery: "", product: "All", status: "All" });

  const calculateCommission = (item) => {
    return (item.fixedComm || 0) + (item.sourceAmount * (item.percentage || 0)) / 100;
  };

  const filteredData = initialData.filter((item) => {
    const matchesSearch = item.agentName.toLowerCase().includes(filters.searchQuery.toLowerCase()) || 
                          item.id.toLowerCase().includes(filters.searchQuery.toLowerCase());
    const matchesProduct = filters.product === "All" || item.product === filters.product;
    const matchesStatus = filters.status === "All" || item.status === filters.status;
    return matchesSearch && matchesProduct && matchesStatus;
  });

  const getProductStats = (productName) => {
    const productTxns = filteredData.filter(item => item.product === productName);
    const totalVolume = productTxns.reduce((acc, item) => acc + item.sourceAmount, 0);
    const totalComm = productTxns.reduce((acc, item) => acc + calculateCommission(item), 0);
    return { totalVolume, totalComm };
  };

  const productsList = [
    { name: "Loan Disbursed", label: "Loan Disbursed" },
    { name: "Loan Applied", label: "Loan Applied" },
    { name: "EMI Collection", label: "EMI Collection" },
    { name: "Savings Account", label: "Savings Account" },
    { name: "FD (Fixed Deposit)", label: "Fixed Deposit (FD)" },
    { name: "RD (Recurring)", label: "Recurring Deposit (RD)" },
    { name: "MIS (Monthly Income)", label: "Monthly Income (MIS)" }
  ];

  const totalCommission = filteredData.reduce((acc, item) => acc + calculateCommission(item), 0);
  const totalBusinessVolume = filteredData.reduce((acc, item) => acc + item.sourceAmount, 0);

  return (
    <div className="acd-dashboard-container">
      {/* Top Header */}
      <div className="acd-header-section">
        <div>
          <h1 className="acd-dashboard-title">Agent Payout Dashboard</h1>
          <p className="acd-dashboard-subtitle">Overview of product wise business and commissions.</p>
        </div>
      </div>

      {/* Main Totals row */}
      <div className="acd-grand-summary-grid">
        <div className="acd-grand-card bg-dark">
          <p>Total Business Volume</p>
          <h2>₹{totalBusinessVolume.toLocaleString("en-IN")}</h2>
        </div>
        <div className="acd-grand-card bg-primary">
          <p>Total Commission Earned</p>
          <h2>₹{totalCommission.toLocaleString("en-IN")}</h2>
        </div>
      </div>

      {/* Product Grid - Very Clean */}
      <h3 className="acd-section-heading">Product Breakdown</h3>
      <div className="acd-stats-grid">
        {productsList.map((prod, index) => {
          const stats = getProductStats(prod.name);
          return (
            <div className="acd-product-row-card" key={index}>
              <span className="acd-prod-label">{prod.label}</span>
              <div className="acd-prod-values">
                <div><small>Vol:</small> <span>₹{stats.totalVolume.toLocaleString("en-IN")}</span></div>
                <div><small>Comm:</small> <strong className="txt-success">₹{stats.totalComm.toLocaleString("en-IN")}</strong></div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Filters */}
      <div className="acd-filter-card">
        <input 
          type="text" 
          placeholder="Search Agent or Txn ID..." 
          value={filters.searchQuery}
          onChange={(e) => setFilters({ ...filters, searchQuery: e.target.value })}
          className="acd-simple-input"
        />
        <select value={filters.product} onChange={(e) => setFilters({ ...filters, product: e.target.value })} className="acd-simple-select">
          <option value="All">All Products</option>
          {productsList.map((p, i) => <option key={i} value={p.name}>{p.label}</option>)}
        </select>
        <select value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })} className="acd-simple-select">
          <option value="All">All Statuses</option>
          <option value="Paid">Paid</option>
          <option value="Pending">Pending</option>
          <option value="On Hold">On Hold</option>
        </select>
      </div>

      {/* Table */}
      <div className="acd-table-wrapper">
        <table className="acd-main-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Agent Name</th>
              <th>Product</th>
              <th>Business Vol.</th>
              <th>Total Earnings</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((row) => (
                <tr key={row.id}>
                  <td className="acd-txt-id">{row.id}</td>
                  <td>{row.agentName}</td>
                  <td>{row.product}</td>
                  <td>₹{row.sourceAmount.toLocaleString("en-IN")}</td>
                  <td className="acd-earnings-cell">₹{calculateCommission(row).toLocaleString("en-IN")}</td>
                  <td><span className={`acd-badge ${row.status.toLowerCase().replace(" ", "-")}`}>{row.status}</span></td>
                </tr>
              ))
            ) : (
              <tr><td colSpan="6" className="acd-no-records">No records found.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AgentDashboard;